import { DataSource, DateRangeFilter, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDetentionDefaults extends Layout {
    daterangefilterCreationDate: DateRangeFilter;
    panelLeft: Panel;
    panelRight: Panel;
    sourceDetentionProfile: DataSource;
    textboxAuthBlank: Textbox;
    textboxAuthStatus: Textbox;
    textboxBillingApproved: Textbox;
    textboxCustomerId: Textbox;
    textboxDescr: Textbox;
    textboxDetentionChargeStatus: Textbox;
    textboxDetentionPaymentStatus: Textbox;
    textboxId: Textbox;
    textboxLocationsList: Textbox;
    textboxOperationsUserId: Textbox;
    textboxPaymentApproval: Textbox;
    textboxStatus: Textbox;
}
